import React, { useEffect, useRef, useState } from 'react';
import dateFormat, { masks } from "dateformat";


import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { Card, Spin } from 'antd';
import useSWR from 'swr';
import { getNewData } from 'Api/api';
import ReactToPrint from 'react-to-print';
import { ToWords } from 'to-words';
import INDShow from '../../components/INRShow'; 

const InvoicePage = () => {
  const [gst, setGst] = useState(true)

  const receipt_id = localStorage.getItem("receipt_id");


  const tableRef = useRef()
  console.log("id_", receipt_id);

  const { data: newData,isLoading, error, mutate, } = useSWR(
    `/admin/adminInvoice/invoice?receipt_id=${receipt_id}`,
    getNewData,
    {
      onSuccess: (data) => {

        console.log("data______________",data)
      setGst(data?.data?.order_details[0]?.inStateTax)
      }
      
        //console.log("saddddddd",data?.data.order_details[0]?.inStateTax),
    }
  );

  if (isLoading) return <Spin>loading...</Spin>

  
  const mapData = newData?.data?.order_details[0]?.monthly_payments

  const toWords = new ToWords({
    localeCode: 'en-IN',
    converterOptions: {
      currency: true,
      currencyOptions: {
        name: 'Rupee',
        plural: 'Rupees',
        fractionalUnit: { name: 'Paisa', plural: 'Paise' },
      },
    },
  });

  const pStyle = {
    fontSize: '9px',
  };
  const hStyle = {
    fontSize: '12px',

  }
  const tStyle = {
    fontSize: '9px',
    border: "1px solid gray"
  }
  const thStyle = {
    borderRight: "1px solid gray"
  }
  const titemStyle = {
    fontWeight: "bolder",
    textAlign: "left",
    paddingLeft: "4px",
    borderRight: "1px solid gray"

  }
  const tRateStyle = {
    fontWeight: "bolder",
    textAlign: "right",
    paddingRight: "4px",
    borderRight: "1px solid gray"
  }
  const tGstRateStyle = {
    fontWeight: "bolder",
    textAlign: "right",
    paddingRight: "4px",
    borderRight: "1px solid gray",

  }
  const tGtotalStyle = {
    fontSize: '12px',
    fontWeight: "bolder",
    textAlign: "right",
    paddingRight: "4px",
    borderRight: "1px solid gray",

  }

  const tItemTotalStyle = {
    fontSize: "12px",
    textAlign: "right",
    paddingRight: "4px",
    borderRight: "1px solid gray"
  }

  const t2RateStyle = {
    fontWeight: "bolder",
    textAlign: "right",
    paddingRight: "4px",
    border: "1px solid gray"
  }

  const tpriceStyle = {
    border: "1px solid gray",
    fontWeight: "bolder"
  }
  const t2priceStyle = {
    border: "1px solid gray",
    fontWeight: "bolder",
    textAlign: "right",
    paddingRight: "4px",
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox
          mx={2}
          mt={-0}
          py={1}
          px={1}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            Admin List
          </MDTypography>
        </MDBox>
        <div  style={{ border: "2px dotted #843737", margin: "10px" }} item xs={12} gutter={16}>
          <Card ref={tableRef}  >
            <div className=" bg-white max-w-4xl mx-auto font-mono text-sm ">
              {/* Header */}  <h6 className="text-center items-start mb-0">INVOICE</h6>
              <div style={{ display: "flex", border: "1px solid gray" }} className='  border-gray-300' >

                <div className="flex w-50  items-start mb-1 text-start  w-30%">
                  <div style={{ borderBottom: "1px solid gray" }} className=' p-1 border-gray-300'>
                    <h5 style={hStyle} className="font-bold p-0 m-0">UBK INFOTECH PVT LTD</h5>
                    <p style={pStyle} className="font-bold p-0 m-0 ">191,Debinibas Road, 2nd Floor,Near Bogola Mandir,Motijheel Kolkata-700074</p>
                    <p style={pStyle} className="font-bold p-0 m-0">PH: 6200938310/8617758895 </p>
                    <p style={pStyle} className="font-bold p-0 m-0">E-Mail: info@ubkinfotech.com</p>
                    <p style={pStyle} className="font-bold p-0 m-0">GSTIN/UIN: 19AACCU7698D1ZT</p>
                    <p style={pStyle} className="font-bold p-0 m-0">State Name: West Bengal, Code: 19</p>
                    <p style={pStyle} className="font-bold p-0 m-0">CIN: U72900WB2021PTC242955</p>
                  </div>

                  <div className="flex w-100 p-1 items-start mb-1 text-start ">
                    <p style={hStyle} className="font-bold p-0 m-0">Buyer (Bill to)</p>
                    
                    <h5 style={hStyle} className="font-bold p-0 m-0"> {newData.data.buyer_details.company_name? newData.data.buyer_details.company_name:   newData.data.buyer_details.first_name+" "+newData.data.buyer_details.last_name} </h5>

                    <p style={pStyle} className="font-bold p-0 m-0">{newData.data.buyer_details.location} </p>
                    <p style={pStyle} className="font-bold p-0 m-0">PH: {newData.data.buyer_details.phone} </p>
                    <p style={pStyle} className="font-bold p-0 m-0">Email:{newData.data.buyer_details.email_id}</p>
                    <p style={pStyle} className="font-bold p-0 m-0">GSTIN/UIN: {newData?.data?.buyer_details?.gstin?newData?.data?.buyer_details?.gstin:""}</p>
                    <p style={pStyle} className="font-bold p-0 m-0">State Name: {newData.data.buyer_details.state_name} &nbsp;&nbsp;&nbsp; State Code: {newData.data.buyer_details.state_code}</p>
                  </div>
                </div>

               
                <div className="flex mb-6 w-50">
                  <div className="d-flex justify-around w-1/2 ">
                    <div style={{ borderLeft: "1px solid gray", paddingLeft: "1px" }} className="w-50  grid grid-cols-2 gap-0">
                      <div style={pStyle} >
                        <p className="font p-0 m-0">Invoice No.</p>
                        <p style={{ fontWeight: "bolder" }} className="fw-bold p-0 m-0">{newData.data.order_details[0].receipt_no}</p>
                      </div>
                      <div style={pStyle}>
                        <p className=" font-bold p-0 m-0 border-top border-gray-400">Note</p>
                        <p className="fw-bold p-0 m-2">{newData.data.order_details[0].notes}</p>
                      </div>
                      <div style={pStyle} >
                        <p className="font-bold p-0 m-0 border-top border-gray-400">Reference No. & Date</p>
                        <p className="fw-bold p-0 m-2"></p>

                      </div>
                     
                    </div>
                    <div style={{ borderLeft: "1px solid lightgray", paddingLeft: "1px" }} className="w-50 grid grid-cols-2 gap-0">
                      <div style={pStyle}>
                        <p className="font-bold p-0 m-0 border-left border-gray-400 ">Dated</p>
                        <p style={{ fontWeight: "bolder" }} className="fw-bold p-0 m-0">{newData.data.order_details[0].receipt_date}</p>
                        

                      </div>
                      <div style={pStyle}>
                        <p className=" font-bold p-0 m-0 border-top border-gray-400">Mode/Terms of Payment</p>
                        <p className="fw-bold p-0 m-0"> {newData.data.order_details[0].payment_mode} </p>

                     
                      </div>
                  
                      <div style={pStyle}>
                        <p className="font-bold p-0 m-0 border-top border-gray-400">Dated</p>
                        <p className="fw-bold p-0 m-2"></p>

                      </div>
                     
                      <div style={pStyle}>
                        <p className="font-bold  p-0 mt-5 mb-5 "></p>
                        <p className="fw-bold p-0 m-2"></p>

                      </div>

                    </div>
                  </div>
                  <div style={{ margineTop: "10px", height: "120px", borderLeft: "1px solid gray", borderTop: "1px solid gray", padding: "2px" }} >
                    <p style={hStyle}>
                      Terms of Delivery
                    </p>
                  </div>
                </div>
              </div>

          

              {/* Invoice Table */}
              <div className="w-full mb-0">
                <table className="invoicetavle w-full  w-100" style={{ textAlign: "center", borderCollapse: 'collapse', width: '100%', borderCollapse: 'collapse' }} >
                  <thead style={{ borderBottom: "1px solid gray" }}>
                    <tr style={tStyle} className="  bg-gray-100">
                      <th style={{
                        borderRight: "1px solid gray",
                        width: "3%"
                      }} className="p-1 w-12 text-left">Sl No.</th>
                      <th style={{
                        borderRight: "1px solid gray",
                        width: "40%"
                      }} className="p-1 text-left">Description of Services</th>
                      <th style={thStyle} className="p-1 w-20 text-right">HSN/SAC</th>
                      <th style={thStyle} className="p-1 w-16 text-right">Quantity</th>
                      <th style={thStyle} className="p-1 w-16 text-right">Rate</th>
                      <th style={thStyle} className="p-1 w-16 text-right">Per</th>
                      {/* <th style={thStyle} className="p-1 w-16 text-right">Disc.</th> */}
                      <th className="p-1 w-24 text-right">Amount (Incl. of Tax)</th>
                    </tr>
                  </thead>

                  <tbody style={{ height: "450px" }}>
                    {mapData?.map((data, index) => {
                      return (
                        <tr style={{ fontSize: "9px",height: '15px' }} key={index} >
                          <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left">{index + 1}</td>
                          <td style={titemStyle} className=" text-left">{dateFormat(data?.monthly_schedule_payment_date, 'mmmm, yyyy')}</td>
                          <td style={thStyle} className=" text-right">997331</td>
                          <td style={thStyle} className=" text-right">1 Month</td>
                          <td style={tRateStyle} className=" text-right"><INDShow amount={data?.recived_amount}/></td>
                          <td style={thStyle} className=" text-right">Month</td>
                          {/* <td style={tRateStyle} className=" text-right">{data?.discount}</td> */}
                          <td style={tRateStyle} className="text-right"><INDShow amount={data?.recived_amount}/></td>
                        </tr>
                      );
                    })}

                    {/* item total  */}
                    <tr style={{ fontSize: "9px", height: '25px', marginTop: "20px" }}  >
                      <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left"></td>
                      <td style={tItemTotalStyle} className=" text-left">TOTAL</td>
                      <td style={thStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      <td style={tRateStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      {/* <td style={tRateStyle} className=" text-right"></td> */}
                      <td style={tItemTotalStyle} className=" text-right"><INDShow amount={newData.data.order_details[0].main_amount}/></td>
                    </tr>
                    <tr style={{ fontSize: "10px",height: '20px', fontStyle: "italic" }}  >
                        <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left"></td>
                        
                        <td style={tRateStyle} className=" text-left">{Number(newData.data.order_details[0].discount) === 0 ? "" : 'DISCOUNT'}</td>
                        
                        <td style={thStyle} className=" text-right"></td>
                        <td style={thStyle} className=" text-right"></td>
                        <td style={tRateStyle} className=" text-right"></td>
                        <td style={thStyle} className=" text-right"></td>
                        {/* <td style={tRateStyle} className=" text-right"></td> */}
                        <td style={tGstRateStyle} className=" text-right">{Number(newData.data.order_details[0].discount) === 0 ? "" :  <INDShow amount={ `-${ Number(newData.data.order_details[0].discount)}`}/>} </td>
                      </tr>
                    {/* GST Amount */}
                    {gst ?
                      <tr style={{ fontSize: "9px", height: '20px', fontStyle: "italic" }}  >
                        <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left"></td>
                        <td style={tRateStyle} className=" text-left"> GST </td>
                        <td style={thStyle} className=" text-right"></td>
                        <td style={thStyle} className=" text-right"></td>
                        <td style={tRateStyle} className=" text-right"></td>
                        <td style={thStyle} className=" text-right"></td>
                        {/* <td style={tRateStyle} className=" text-right"></td> */}
                        <td style={tGstRateStyle} className=" text-right"><INDShow amount={newData.data.order_details[0].tax_amount}/></td>
                      </tr>
                      : ""}
                   
                    {gst ? ""
                      :
                      <tr style={{ fontSize: "9px",height: '20px', fontStyle: "italic" }}  >
                        <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left"></td>
                        <td style={tRateStyle} className=" text-left"> IGST </td>
                        <td style={thStyle} className=" text-right"></td>
                        <td style={thStyle} className=" text-right"></td>
                        <td style={tRateStyle} className=" text-right"></td>
                        <td style={thStyle} className=" text-right"></td>
                        {/* <td style={tRateStyle} className=" text-right"></td> */}
                        <td style={tGstRateStyle} className=" text-right"><INDShow amount={newData.data.order_details[0].tax_amount}/></td>
                      </tr>
                    }
                    <tr style={{ fontSize: "9px", height: '20px', fontStyle: "italic" }}>
                      <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left"></td>
                      <td style={tRateStyle} className=" text-left">
                        {Number(newData.data.order_details[0].round_off) === 0  ? ""  : 
                          "ROUND OFF"
                         }
                        </td>
                      
                      <td style={thStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      <td style={tRateStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      {/* <td style={tRateStyle} className=" text-right"></td> */}
                      <td style={tGstRateStyle} className=" text-right">{Number(newData.data.order_details[0].round_off) === 0 ? "" :  <INDShow amount={ `${ Number(newData.data.order_details[0].round_off)}`}/>}</td>
                    </tr>
                    {/* Row for the visual blank space with vertical borders */}
                    <tr style={{ fontSize: "9px", height: 'auto' }}>
                      <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left"></td>
                      <td style={tRateStyle} className=" text-left"></td>
                      <td style={thStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      <td style={tRateStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      {/* <td style={tRateStyle} className=" text-right"></td> */}
                      <td style={tGstRateStyle} className=" text-right"></td>
                    </tr>
                  
                  </tbody>
                  <tfoot >
                    <tr style={tStyle}  >
                      <td style={{ borderLeft: "1px solid gray", borderRight: "1px solid gray" }} className=" text-left"></td>
                      <td style={tRateStyle} className=" text-left">GRAND TOTAL</td>
                      <td style={thStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      <td style={tRateStyle} className=" text-right"></td>
                      <td style={thStyle} className=" text-right"></td>
                      {/* <td style={tRateStyle} className=" text-right"></td> */}
                      <td style={tGtotalStyle} className=" text-right"><INDShow amount={newData.data.order_details[0].grand_total}/></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Amount in Words */}
              <div style={{ borderLeft: "1px solid gray", fontSize: "12px", borderRight: "1px solid gray" }} className="p-1 mb-0">
                <p>Amount Chargeable (in words):<span style={{ fontWeight: "bolder" }} className="font-bold">{toWords.convert(newData.data.order_details[0].payment_amount, { currency: true })}
                </span> </p>
              </div>

              {/* Gst */}
              <div className="w-full mb-0">
                <table style={{ textAlign: "center",}} className="w-full  w-100">
                  <thead>
                    <tr>
                      <th style={{
                        fontSize: '9px',
                        border: "1px solid gray",
                        width: "40%"
                      }} rowspan="2" colspan="2">HSN/SAC</th>
                      <th style={tStyle} rowspan="2" colspan="2">Taxable Value</th>
                      {gst ? <th style={tStyle} colspan="2">CGST</th> : ""}

                      {gst ? <th style={tStyle} colspan="2">SGST/UTGST</th> : ""}
                      {gst ? "" : <th style={tStyle} colspan="2">IGST</th>}
                      <th style={tStyle} rowspan="2" >Total Tax Amount</th>
                    </tr>
                    <tr>
                      {gst ?
                        <th style={tStyle}>Rate</th>
                        : ""
                      }
                      {gst ?
                        <th style={tStyle}>Amount</th>
                        : ""
                      }
                      {gst ?
                        <th style={tStyle}>Rate</th>
                        : ""
                      }
                      {gst ?
                        <th style={tStyle}>Amount</th>
                        : ""
                      }
                      {gst ? " " : <th style={tStyle}>Rate</th>}

                      {gst ? " " : <th style={tStyle}>Amount</th>}
                    </tr>
                  </thead>
                  <tbody>


                    {/* {tax.map((item,index) => (
                         <div></div>
                    ))} */}
                    <tr style={tStyle}>
                      <td colspan="2" style={{
                        fontSize: '9px',
                        border: "1px solid gray", textAlign: "start", paddingLeft: "2px"
                      }}> 997331
                      </td>
                      <td colspan="2" style={t2RateStyle}><INDShow amount={newData.data.order_details[0].payment_amount}/></td>
                      {gst ?
                        <><td style={t2RateStyle}>{newData.data.order_details[0].cgst_perc} % </td>
                          <td style={t2RateStyle}> <INDShow amount={newData.data.order_details[0].cgst}/></td>
                          <td style={t2RateStyle}> {newData.data.order_details[0].sgst_perc} %</td>
                          <td style={t2RateStyle}> <INDShow amount={newData.data.order_details[0].sgst}/></td>
                          <td style={t2RateStyle}><INDShow amount={newData.data.order_details[0].tax_amount}/></td></>
                        : ""}
                      {gst ? "" :
                        <><td style={t2RateStyle}>{newData.data.order_details[0].igst_perc} %</td>
                          <td style={t2RateStyle}> ₹ {newData.data.order_details[0].igst} </td>
                          <td style={t2RateStyle}> ₹ {newData.data.order_details[0].igst} </td>
                        </>}

                    </tr>

                    <tr style={tStyle}>
                      <td colspan="2" style={{
                        border: "1px solid gray",
                        fontWeight: "bolder",
                        textAlign: "Right",
                        paddingRight: "2px"
                      }}> TOTAL</td>
                      <td colspan="2" style={t2priceStyle}> <INDShow amount={newData.data.order_details[0].payment_amount}/></td>
                      <td style={tStyle}> </td>
                      {gst ? <td style={t2priceStyle}> <INDShow amount={newData.data.order_details[0].cgst}/></td> : ""}
                      {gst ? "" : <td style={t2priceStyle}> </td>}
                      {gst ? <td style={t2priceStyle}> </td> : ""}
                       {/* {gst ? "" : <td style={t2priceStyle}> </td>}  */}
                      {gst ? <td style={t2priceStyle}> <INDShow amount={newData.data.order_details[0].sgst}/></td> : ""}
                      <td style={t2priceStyle}><INDShow amount={newData.data.order_details[0].tax_amount}/></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Declaration and Signature */}
              <div style={{ borderLeft: "1px solid gray", fontSize: "12px", borderRight: "1px solid gray", borderBottom: "1px solid gray", paddingLeft: "2px" }} className=" mb-0">
                 <div>
                  <p> TAX Amount  (in words):
                    <span style={{ fontWeight: "bolder" }} className="font-bold">
                      {toWords.convert(newData?.data?.order_details[0]?.tax_amount, { currency: true })} 
                      </span></p>
                </div>

                <div className='d-flex'>
                  <div className='w-50'>

                  </div>
                  <div className='w-50'>
                    <p className='p-0 m-0'>Company's bank Details</p>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "8fr 1fr 20fr",
                        // paddingLeft: 10,
                        // paddingRight: 10,
                        paddingLeft: 5,
                        color: "#000",
                        fontSize: 9,
                      }}
                    >
                      <><div >Bank Name</div>
                        <div style={{ textAlign: "center" }}>:</div>
                        <div style={{ fontWeight: 'bold' }}>STATE  BANK OF INDIA</div></>
                      <><div>A/C No</div>
                        <div style={{ textAlign: "center" }}>:</div>
                        <div style={{ fontWeight: 'bold' }}>39856263832</div></>
                      <><div>Branch</div>
                        <div style={{ textAlign: "center" }}>:</div>
                        <div style={{ fontWeight: 'bold' }}>CALCUTTA AIRPORT</div></>
                        <><div>IFSC Code</div>
                        <div style={{ textAlign: "center" }}>:</div>
                        <div style={{ fontWeight: 'bold' }}>SBIN0003029</div></>
                    </div>
                  </div>

                </div>
                <div className='d-flex'>
                  <div style={{ marginTop: "-20px" }} className='w-50'>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "8fr 1fr 20fr",
                        // paddingLeft: 10,
                        // paddingRight: 10,
                        paddingLeft: 2,
                        color: "#000",
                        fontSize: 9,
                      }}
                    >
                      <><div>Company's PAN</div>
                        <div style={{ textAlign: "center" }}>:</div>
                        <div style={{ fontWeight: 'bold' }}>AACCU7698D</div></>
                    </div>
                    <p className='p-0 m-0'>Dectlaration</p>
                    <hr style={{ width: "70px" }} className='p-0 m-0' />
                    <p style={{ maxWidth: "400px" }} className='p-0 m-0'>
                      All payments are non-refundable under any circumstances.
                    </p>
                  </div>



                  <div className='w-50'>
                    <div style={{ borderLeft: "1px solid gray", borderTop: "1px solid gray", display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "flex-end" }}>
                      <p style={{}}>
                       UBK INFOTECH PVT LTD
                      </p>
                      <p style={{ marginBottom: "-4px" }} >Authority Signature</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="text-center p-0, m-0">
                <p style={{ fontSize: "11px", margin: "0px" }} >SUBJECT TO KOLKATA JURISDICTION</p>
                <p style={{ fontSize: "10px", margin: "0px" }}>This is computer generated invoice no signature required</p>
              </div>
            </div>
          </Card>
        </div >

        {/* <div style={{ display: "flex", justifyContent: "center", textAlign: "center", alignItems: "center" }}>
          <button style={{ color: "white", "backgroundColor": "blue", border: "none" }} onClick={handlePrint} >
            Print Invoice
          </button>
        </div> */}
        
        <div style={{ display: "flex" }}>
          <div style={{ width: "45%" }}>

          </div>
          <div style={{ width: "55%" }} className="d-print-none mt-4 ">
            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}
            >
              <ReactToPrint
                trigger={() => (
                  <a
                    className="btn btn-success me-1 search-button"
                    style={{ background: "green" }}
                  >
                    Print
                  </a>
                )}
                content={() => tableRef.current}
              />


              {/* <div className="btn btn-success me-1 search-button"
              >Send Email</div> */}
            </div>
          </div>
        </div>



      </DashboardLayout>
    </>
  );
};

export default InvoicePage;